<div fxLayout="row"  class="field-display">
    <div [fxFlex]="fieldWidth" class="label">
        {{name}}
    </div>
    <div [fxFlex]="valueWidth">
        <span *ngIf="value">
            {{value}}
        </span>
        <span *ngIf="!value">
            <ng-content></ng-content>
        </span>
    </div>
</div>